<template>
  <v-card>
    <v-app-bar color="primary">
      <v-app-bar-nav-icon>
        <v-icon medium color="white" @click="$emit('simple-close')" :disabled="loading">close</v-icon>

      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <span class="title white--text font-weight-bold"> {{ $language.settings['Profile Information'] }}
        </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click="favorite">
        <v-icon v-if="isFav" color="white">
          favorite
        </v-icon>
        <v-icon v-else color="white">
          favorite_border
        </v-icon>
      </v-app-bar-nav-icon>

    </v-app-bar>
    <v-container>
      <v-row align="center" class="pt-15" v-if="loading">
        <v-col cols="12" align="center">
          <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
        </v-col>
        <v-col cols="12" align="center">
          <h4 class="grey--text text--darken-3 mt-3">{{ $language.settings['Loading user details'] }}</h4>
        </v-col>
      </v-row>
      <v-row no-gutters align="center">
        <v-avatar size="110">
          <v-img :src="profile.photoURL" @click="photoDialog = true">
          </v-img>
        </v-avatar>
        <v-col>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="title py-1">
                {{ profile.name }}
              </v-list-item-title>
              <v-list-item-subtitle class="subtitle py-1">
                <v-row no-gutters align="baseline" wrap>

                  <v-rating v-model="profile.rating"  small dense background-color="grey darken-1" empty-icon="$vuetify.icons.ratingFull" half-increments readonly></v-rating>
                  <span> ({{ profile.rating }})</span>

                </v-row>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="subheading py-1">
                <v-row no-gutters align="end">
                  <v-col cols="12">
                    <span class="subheading">
                      {{ profile.reviewCount ? profile.reviewCount + `${ $language.settings['reviews'] }.` : `${ $language.settings['No reviews'] }.` }}
                    </span>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="subheading py-1">
                <v-row no-gutters align="end">
                  <v-col cols="12">
                    <span class="subheading">
                      {{ profile.completedJobs ? profile.completedJobs + ` ${ $language.settings['completed jobs'] }.` : `${ $language.settings['No completed jobs'] }.` }}
                    </span>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
        <v-row no-gutters align="start">

          <v-col cols="12" md="6">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title">
                  {{ $language.settings['Skills'] }}
                </v-list-item-title>
                <v-row>
                  <v-col cols="12">
                    <template v-for="(skill, index) in profile.categories">
                      <v-chip class="pa-1 ma-1" v-if="index<10" small :key="index"> {{ skill }} </v-chip>
                      <v-chip class=" pa-1 ma-1" v-if="index===10" small :key="index">(+{{ profile.categories.length - 10 }} {{ $language.jobSearch['others'] }}) </v-chip>
                    </template>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <div class="title grey--text text--darken-3 mb-3"></div>
          </v-col>
          <v-col cols="12" v-if="!$vuetify.breakpoint.mdAndUp">
          <v-divider ></v-divider>
        </v-col>
          <v-col cols="12" md="6">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title">
                  {{ $language.settings['Reviews'] }}
                </v-list-item-title>
                <v-window v-model="currentReview" :touch="{ left: prev, right: next }" v-if="(profile || {}).ratings">
                    <v-window-item v-for="(review, index) in (profile.ratings || {})" :key="index">

                      <v-col cols="12" class="body-1 grey--text text--darken-3 pa-3 text-xs-center" align="center">
                        <v-rating v-model="review.rating" class="mb-1"  background-color="grey darken-1" empty-icon="$vuetify.icons.ratingFull" half-increments readonly></v-rating>
                      </v-col>
                      <v-col cols="12" class="body-1 grey--text text--darken-3 pa-3 text-xs-left" align="center">
                        {{ review.comment }}
                      </v-col>
                      <v-col cols="12" class="caption text-xs-right mt-2" align="center">
                        - From {{ review.ratedByName }} ({{ review.ratingDate|formatShortDate }})
                      </v-col>

                    </v-window-item>
                </v-window>
                <v-col cols="12" align="center">
                   <div class="text-xs-center mt-1" v-if="Object.entries((profile || {}).ratings || []).length > 1">
                  <v-icon color="info" class="mx-3" style="vertical-align: middle;" @click="prev">fas fa-arrow-circle-left</v-icon>
                  <span class="">{{ currentReview + 1 }} / {{ Object.entries(profile.ratings || []).length }}</span>
                  <v-icon color="info" class="mx-3" style="vertical-align: middle;" @click="next">fas fa-arrow-circle-right</v-icon>
                </div>
                <div v-if="!(profile || {}).ratings" class="text-xs-center py-3 grey--text text--darken-3">
                  {{ $language.settings['No reviews yet'] }}.
                </div>
                </v-col>

              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>

      </v-row>

    </v-container>

    <v-layout column fill-height align-space-between justify-start class="white">

      <v-flex v-if="loading">
        <v-layout fill-height column justify-center align-center style="margin-top: -25px">
          <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
          <h4 class="grey--text text--darken-3 mt-3">{{ $language.settings['Loading user details'] }}</h4>
        </v-layout>
      </v-flex>

      <v-app-bar  flat v-if="job && profileRef.status ==='Applied'" bottom fixed tile>
        <v-row align-space-around>
          <v-col cols="6" align="center" justify="center">
            <v-btn large block color="red" @click.native.stop="declineDialog = true">
              <span :class="`${ $vuetify.breakpoint.xs ? 'caption text-none white--text font-weight-bold' : $vuetify.breakpoint.sm ? 'body-2 text-none white--text font-weight-bold' : 'body-2 text-none white--text font-weight-bold' }`">
                {{ $language.settings['Decline this application'] }}
              </span>
              <v-icon small class="ml-2" color="white">thumb_down</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6" align="center" justify="center">
            <v-btn large block color="green" @click.native.stop="hireDialog = true" :disabled="hiredMax">
              <span :class="`${ $vuetify.breakpoint.xs ? 'caption text-none white--text font-weight-bold' : $vuetify.breakpoint.sm ? 'body-2 text-none white--text font-weight-bold' : 'body-2 text-none white--text font-weight-bold' }`">
                {{ $language.settings['Hire this worker'] }}
              </span>
              <v-icon small class="ml-2" color="white">thumb_up</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-app-bar>
      <v-app-bar color="green" flat v-if="job && profileRef.status ==='Hired'" bottom fixed tile>
        <v-row align-space-around>
          <v-col cols="12" align="center" justify="center">
            <span :class="`${ $vuetify.breakpoint.xs ? 'text-none white--text font-weight-bold' : $vuetify.breakpoint.sm ? 'body-2 text-none white--text font-weight-bold' : 'body-2 text-none white--text font-weight-bold' }`">
              {{ $language.settings['This worker was approved for this job'] }}.
            </span>
            <v-icon small class="ml-2" color="white">thumb_up</v-icon>
          </v-col>
        </v-row>
      </v-app-bar>

      <v-app-bar color="red" flat v-if="profileRef.status === 'Declined' || profileRef.hefeDeclined" bottom fixed tile>
        <v-row align-space-around>
          <v-col cols="12" align="center" justify="center">
            <span :class="`${ $vuetify.breakpoint.xs ? 'text-none white--text font-weight-bold' : $vuetify.breakpoint.sm ? 'body-2 text-none white--text font-weight-bold' : 'body-2 text-none white--text font-weight-bold' }`">
              {{ profile.hefeDeclined ? 'You declined the application of this user' : 'This worker declined your offer' }}.
            </span>
            <v-icon small class="ml-2" color="white">thumb_down</v-icon>
          </v-col>
        </v-row>
      </v-app-bar>

    </v-layout>
    <v-dialog v-model="hireDialog" persistent max-width="290">
      <v-card class="py-1">
        <v-card-title class="title py-3">{{ $language.settings['Confirm Hire?'] }}</v-card-title>
        <v-card-text>{{ $language.settings['Select AGREE to confirm'] }}. </v-card-text>
        <v-card-actions class="pt-4 pr-2">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="hireDialog = false" :disabled="buttonLoading">{{ $language.settings['cancel'] }}</v-btn>
          <v-btn color="primary" depressed @click.native="confirmHire" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.settings['Agree'] }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="declineDialog" persistent max-width="290">
      <v-card class="py-1">
        <v-card-title class="title py-3">{{ $language.settings['Decline this Applicant?'] }}</v-card-title>
        <v-card-text>{{ $language.settings['Select DECLINE to remove the applicant from this job'] }}. </v-card-text>
        <v-card-actions class="pt-4 pr-2">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="declineDialog = false" :disabled="buttonLoading">{{ $language.settings['cancel'] }}</v-btn>
          <v-btn color="primary" depressed @click.native="declineHire" :loading="buttonLoading">{{ $language.settings['Agree'] }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.show" color="success" :timeout="1500">
      {{ snackbar.message }}

    </v-snackbar>
  </v-card>

</template>

<script>
import {
  mapState
} from 'vuex'
import {
  object
} from 'rxfire/database'
import {
  map
} from 'rxjs/operators'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['profileRef', 'job', 'userFav', 'status'],
  data () {
    return {
      dummyReviews: [{
        client: 'Naomi Hunter',
        rating: 3.75,
        text: 'Extraordinary professional! It has been an honor to work with some-one of her calibre. She is deliberate with her marketing tactics and implements with great attention to every detail. For me, one of her most important skill sets is her ability to self manage and keep our projects  moving forward no matter my availability or the lack thereof. No worries once you have agreed on a gameplan and a course of action. Additionally, Diana puts her heart and soul into her work. She gives you everything she’s got when she gets into a project. I am humbled to have worked with some-one of such high integrity and so committed to our mutual success. A truly great business partner.'
      },
      {
        client: 'Frank Jaeger',
        rating: 2,
        text: 'This was my second contract with [name]. First one was pretty straight-forward and the second one was ongoing. Mentioning this only because of the communication. If hired for one-time task, [name] is excellent with communication – knows what he wants, very flexible, appreciates the freelancer’s expertise, open for suggestions and development, very smart guy. For long-term contract though, he tends to disappear from time to time, long periods without feedback or any communication whatsoever – it may be frustrating if you are not used to such kind of working relationship 🙂 Either way, I strongly recommend him as a client – it was a pleasure working with him!'
      }
      ],
      currentReview: 0,
      buttonLoading: false,
      snackbar: {
        show: false,
        message: '',
        error: false
      },
      sub: '',
      name: '',
      title: '',
      text: 'Profile Successfully Updated',
      rating: 4.9,
      model: '',
      profile: {},
      loading: false,
      hireDialog: false,
      declineDialog: false,
      index: 0
    }
  },
  computed: {
    ...mapState(['currentUser']),
    isFav () {
      if (this.userFav !== undefined) {
        if (this.userFav[this.profileRef.profileId] !== undefined) {
          return this.userFav[this.profileRef.profileId]
        }
      }
      return false
    },
    hiredMax () {
      return !(parseInt(this.job.public.workers) - parseInt(this.job.public.hiredWorkers) > 0)
    }
  },
  methods: {

    next () {
      if (this.currentReview > this.profile.length) {
        this.currentReview = 0
      } else {
        this.currentReview += 1
      }
    },

    prev () {
      if (this.currentReview !== 0) {
        this.currentReview -= 1
      } else {
        this.currentReview = this.profile.length - 1
      }
    },

    closeDialog () {
      this.sub.unsubscribe()
    },

    async confirmHire () {
      this.hireDialog = false
      this.closeDialog()
      this.$emit('confirm-hire', {
        profileId: this.profileRef.profileId
      })
      this.$emit('close', {
        show: true,
        message: this.$language.settings['This worker was approved for this job.']
      })
    },

    async declineHire () {
      this.buttonLoading = true
      var updates = {}
      var updatedDate = new Date()
      var newKey = await fb.database.ref().child(`user/${this.profileRef.profileId}/profile/notifications`).push().key

      var notification = {
        'notificationType': 'Hire Declined',
        'notificationText': `You have been denied, better luck tomorrow.`,
        'notificationDate': updatedDate,
        'jobId': '',
        'defaultTab': '',
        route: 'obr'
      }
      updates[`jobs/${this.job._key}/applicants/${this.profileRef.profileId}/status`] = 'Declined'
      updates[`jobs/${this.job._key}/applicants/${this.profileRef.profileId}/status`] = 'Declined'
      updates[`jobs/${this.job._key}/public/numberOfApplicants`] = parseFloat(this.job.public.numberOfApplicants - 1)
      updates[`user/${this.profileRef.profileId}/jobs/${this.job._key}/status`] = 'Declined'
      updates[`user/${this.profileRef.profileId}/jobs/${this.job._key}/updatedDate`] = updatedDate
      updates[`user/${this.profileRef.profileId}/profile/notifications/${newKey}`] = notification
      await fb.database.ref().update(updates)
      this.buttonLoading = false
      this.declineDialog = false
      this.closeDialog()
      this.$emit('close', {
        show: true,
        message: this.$language.settings['You declined the application of this user.']
      })
    },

    favorite () {
      if (this.isFav) {
        this.removeFavorite()
      } else {
        this.addFavorite()
      }
    },

    async addFavorite () {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/favorites/${this.profileRef.profileId}`] = {
        name: this.profile.name
      }
      await fb.database.ref().update(updates)

      this.snackbar.message = this.$language.settings['Added to favorites!']
      this.snackbar.show = true
    },
    async removeFavorite () {
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/favorites/${this.profileRef.profileId}`] = null
      await fb.database.ref().update(updates)
      this.snackbar.message = this.$language.settings['Removed from favorites!']
      this.snackbar.show = true
    }
  },
  watch: {
    profileRef () {
      // I'm not sure what is this about...
      this.loading = true
      var updates = {}
      if (this.job !== null && this.profileRef.profileId !== undefined) {
        updates[`jobs/${this.job._key}/applicants/${this.profileRef.profileId}/viewed`] = true
        fb.database.ref().update(updates)
      }
      this.sub = object(fb.database.ref(`user/${this.profileRef.profileId}/profile/public`))
        .pipe(map(change => ({
          _key: change.snapshot.key,
          ...change.snapshot.val()
        })))
        .subscribe(profile => {
          // This profileRef comes from job.applicants and has { appliedDate, status, viewed }, etc
          // but then when this query finishes it gets overwritten by the user profile which has none of that.
          // With the status from the profileRef you can know if the user applied, was hired, etc
          // I'm going to merge both objects to keep the important properties
          this.profile = profile

          this.loading = false
        })
    }
  },
  destroyed () {
    this.loading = true
    this.sub.unsubscribe()
  },
  filters: {
  }
}
</script>
<style>
</style>
